import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { AssetManagement } from './pages/AssetManagement';
import { TicketManagement } from './pages/TicketManagement';
import { CRM } from './pages/CRM';
import { QuoteBuilder } from './pages/QuoteBuilder';
import { OrderTracking } from './pages/OrderTracking';
import { UpdateManagement } from './pages/UpdateManagement';
import { NetworkOverview } from './pages/NetworkOverview';
import { SoftwareDistribution } from './pages/SoftwareDistribution';
import { Settings } from './pages/Settings';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    // Check if user is already authenticated
    const authStatus = localStorage.getItem('isAuthenticated');
    setIsAuthenticated(authStatus === 'true');
  }, []);
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
  };
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace data-id="element-3" /> : <Login onLogin={handleLogin} data-id="element-4" />} data-id="element-2" />

        {/* Protected Routes - Pass handleLogout to all pages */}
        <Route path="/" element={isAuthenticated ? <Dashboard onLogout={handleLogout} data-id="element-6" /> : <Navigate to="/login" replace data-id="element-7" />} data-id="element-5" />
        <Route path="/assets" element={isAuthenticated ? <AssetManagement onLogout={handleLogout} data-id="element-9" /> : <Navigate to="/login" replace data-id="element-10" />} data-id="element-8" />
        <Route path="/tickets" element={isAuthenticated ? <TicketManagement onLogout={handleLogout} data-id="element-12" /> : <Navigate to="/login" replace data-id="element-13" />} data-id="element-11" />
        <Route path="/crm" element={isAuthenticated ? <CRM onLogout={handleLogout} data-id="element-15" /> : <Navigate to="/login" replace data-id="element-16" />} data-id="element-14" />
        <Route path="/quotes" element={isAuthenticated ? <QuoteBuilder onLogout={handleLogout} data-id="element-18" /> : <Navigate to="/login" replace data-id="element-19" />} data-id="element-17" />
        <Route path="/orders" element={isAuthenticated ? <OrderTracking onLogout={handleLogout} data-id="element-21" /> : <Navigate to="/login" replace data-id="element-22" />} data-id="element-20" />
        <Route path="/updates" element={isAuthenticated ? <UpdateManagement onLogout={handleLogout} data-id="element-24" /> : <Navigate to="/login" replace data-id="element-25" />} data-id="element-23" />
        <Route path="/network" element={isAuthenticated ? <NetworkOverview onLogout={handleLogout} data-id="element-27" /> : <Navigate to="/login" replace data-id="element-28" />} data-id="element-26" />
        <Route path="/software" element={isAuthenticated ? <SoftwareDistribution onLogout={handleLogout} data-id="element-30" /> : <Navigate to="/login" replace data-id="element-31" />} data-id="element-29" />
        <Route path="/settings" element={isAuthenticated ? <Settings onLogout={handleLogout} data-id="element-33" /> : <Navigate to="/login" replace data-id="element-34" />} data-id="element-32" />

        <Route path="*" element={<Navigate to="/" replace data-id="element-36" />} data-id="element-35" />
      </Routes>
    </Router>;
}